module.exports = __webpack_public_path__ + "img/電気回路_2_6_4.e0923946.png";